export default __webpack_public_path__ + "static/media/vellfire.2aa7527e.jpg";